import KadChartist from 'libs/kad-chartist';

export default function(data) {
  this.$el = $('#admin_category_listing');
  this.$category_modal = $('#category_modal');
  this.$course_modal = $('#course_modal');
  this.$course_input = $('#selected_courses');

  this.courses = ko.observableArray();
  this.categories = ko.observableArray();
  this.barChartLastPage = ko.observable(false);
  this.barChartFirstPage = ko.observable(true);
  this.barChartPerPage = ko.observable(5);
  this.showBarChartPagination = ko.observable(false);

  this.selected_category = ko.observable();
  this.new_category = ko.observable({
    name: ko.observable('')
  });

  this.bindData = data => {
    const mapped_courses = ko.mapping.fromJS(data.courses);
    const mapped_categories = ko.mapping.fromJS(data.categories);

    this.courses(mapped_courses());
    this.categories(mapped_categories());

    this.buildCategoryCharts(data.categories);
  };

  this.initUI = () => {
    this.initCourseTypeahead();

    $('#courseSearch').on('keypress', event => {
     const keycode = event.keyCode || event.which

      if (keycode === '13') {
        $('#courseSearch').blur();
        this.filterChanged();
      }
    });
  };

  this.resetSelected = () => {
    this.client_errors = ko.validation.group(this.new_category(), { deep: true });
    this.selected_category(null);
    this.new_category().name('');
    this.client_errors.showAllMessages(false);
  };

  this.buildCategoryCharts = categories => {
    const donutData = data.categories.map(cat => {
      if(cat.courses.length)
        return { value: cat.courses.length, name: cat.name };
    });

    const enrolledData = data.categories.map(cat => {
      if(cat.enrolled_student_count)
        return { value: cat.enrolled_student_count, name: cat.name };
    });

    const enrolledDataLabels = _.compact(_.pluck(enrolledData, 'name'));

    const barData = {
      labels: enrolledDataLabels,
      series: [
        {
          name: 'Students',
          data: _.compact(_.pluck(enrolledData, 'value'))
        }
      ]
    };

    const donutOptions = {
      type: 'donut',
      data: { series: _.compact(donutData) },
    };

    this.showBarChartPagination(enrolledDataLabels.length > this.barChartPerPage());

    this.donutChart = new KadChartist.Chart('.js-chart-donut', donutOptions);

    this.barChart = new KadChartist.Chart(
      '.js-chart-bar',
      { data: barData, paginatePer: this.barChartPerPage() }
    );
  };

  this.barChartNext = () => {
    this.barChart.nextPage();
    this.checkBarChartPage();
  };

  this.barChartPrev = () => {
    this.barChart.prevPage();
    this.checkBarChartPage();
  };

  this.checkBarChartPage = () => {
    this.barChartLastPage(this.barChart.isLastPage);
    this.barChartFirstPage(this.barChart.isFirstPage);
  };

  /*------------------------------------------COURSE ASSIGNMENT FUNCTIONS---------------------------------------------*/

  this.courseSource = (query, callback) => {
    const lowerQuery = query.toLowerCase()

    const filteredList = $.grep(this.courses(), (item, index) => {
      return item.number().toLowerCase().match(lowerQuery) ||
        item.name().toLowerCase().match(lowerQuery);
    });

    callback( filteredList.map(item => this.courseTag(item)))
  };

  this.courseTag = course => {
    const name = course.name().match(course.number()) ?
      course.name() :
      [course.number(), course.name()].join(": ")

    return {
      id: course.id(),
      number: course.number(),
      name
    }
  }

  this.initCourseTypeahead = () => {
    this.$course_input.tagsinput({
      confirmKeys: [9, 13, 188],
      itemValue: 'id',
      itemText: 'name'
    });

    const $typeaheadInput = $('.bootstrap-tagsinput input', this.$course_input.parent())

    const typeaheadOptions = {
      minLength: 0,
      hint: false,
      highlight: false,
    }

    const typeaheadDataset = {
      name: 'noname',
      displayKey: 'name',
      source: this.courseSource
    }

    const handleSelected = (evt, course) => {
      this.$course_input.tagsinput('add', course)
      evt.target.value = ''
    }

    const handleOpened = () => {
      const ev = $.Event('keydown');
      ev.keyCode = ev.which = 40;

      $(this).trigger(ev);
      $(this).typeahead('val', '');

      return true;
    }

    $typeaheadInput
      .typeahead(typeaheadOptions, typeaheadDataset)
      .bind('typeahead:selected', handleSelected.bind(this))
      .bind('typeahead:opened', handleOpened.bind(this))
  };

  this.selected_courses = key => {
    return this.$course_input.tagsinput('items').map(item => {
      return key ? item[key] : item
    })
  }

  this.selectCourse = (item, event) => {
    this.selected_category(item);

    this.$course_input.tagsinput('removeAll');

    item.courses().forEach(course => {
      this.$course_input.tagsinput('add', this.courseTag(course))
    })

    this.$course_modal.modal('show');
  };

  this.selectedCategoryName = () => {
    return this.selected_category() && this.selected_category().name()
  }

  this.categorySaveAction = (root) => {
    return this.selected_category() ? root.saveCategoryName : root.saveNewCategory
  }

  this.categorySaveText = () => {
    return this.selected_category() ?
      I18n.t('actions.save_changes') :
      I18n.t('actions.save')
  }

  this.categoryValue = () => {
    return (
      this.selected_category() || this.new_category()
    ).name.extend({ required: true })
  }

  this.categoryFieldAction = () => {
    return this.selected_category() ?
      I18n.t("admin.categories.edit_category_name") :
      I18n.t("admin.categories.add_category_name")
  }

  this.categoryAction = () => {
    return this.selected_category() ?
      I18n.t("admin.categories.edit_category") :
      I18n.t("admin.categories.add_category")
  }

  /*--------------------------------------CATEGORY STATE MANAGEMENT FUNCTIONS-----------------------------------------*/

  this.addCategory = () => {
    this.selected_category(null);
    this.new_category().name('');
    this.$category_modal.modal('show');
  };

  this.saveNewCategory = (item, event) => {
    var save = () => {
      this.$category_modal.modal('hide');

      var url = Kadenze.Routes.admin_categories_path();
      var data = {category: ko.mapping.toJS(this.new_category())};
      var method = 'POST';

      Kadenze.UIUtil.makeRequest(url, method, data, this.$el, null, (data, textStatus, xhr) => {
        var mapped_category = ko.mapping.fromJS($.extend(data.category, {courses: []}));
        this.categories.push(mapped_category);
        this.resetSelected();
        Kadenze.UIUtil.showNotice($('#notice_container'), data, 3000);
      }, (xhr, textStatus, errorThrown) => {
        Kadenze.UIUtil.showNotice($('#notice_container'), xhr.responseJSON, 3000);
      });
    };

    this.client_errors = ko.validation.group(this.new_category(), { deep: true });
    if (this.client_errors().length === 0) {
      save();
    } else {
      this.client_errors.showAllMessages();
    }
  };

  this.saveCategory = (item, event) => {
    this.$course_modal.modal('hide');

    var url = Kadenze.Routes.admin_category_path(this.selected_category().id());
    var data = {course_ids: this.selected_courses('id')};
    var method = 'PATCH';

    Kadenze.UIUtil.makeRequest(url, method, data, this.$el, null, (data, textStatus, xhr) => {
      ko.utils.arrayFirst(this.categories(), category => {
        if (category.id() === this.selected_category().id()) {
          var mapped_courses = ko.mapping.fromJS(this.selected_courses());
          category.courses(mapped_courses());
        }
      });

      this.resetSelected();

      Kadenze.UIUtil.showNotice($('#notice_container'), data, 3000);
    }, (xhr, textStatus, errorThrown) => {
      Kadenze.UIUtil.showNotice($('#notice_container'), xhr.responseJSON, 3000);
    });
  };

  this.saveCategoryName = (item, event) => {
    this.$category_modal.modal('hide');

    var url = Kadenze.Routes.admin_category_path(this.selected_category().id());
    var data = {name: this.selected_category().name()};
    var method = 'PATCH';

    Kadenze.UIUtil.makeRequest(url, method, data, this.$el, null, (data, textStatus, xhr) => {
      this.resetSelected();
      Kadenze.UIUtil.showNotice($('#notice_container'), data, 3000);
    }, (xhr, textStatus, errorThrown) => {
      Kadenze.UIUtil.showNotice($('#notice_container'), xhr.responseJSON, 3000);
    });
  };

  this.deleteCategory = (item, event) => {
    var url = Kadenze.Routes.admin_category_path(item.id());
    var method = 'DELETE';
    var deletePrompt = I18n.t('notice.delete_category');

    Kadenze.UIUtil.confirmAction(deletePrompt, () => {
      Kadenze.UIUtil.makeRequest(url, method, null, this.$el, null, (data, textStatus, xhr) => {
        this.categories.remove(item);
        Kadenze.UIUtil.showNotice($('#notice_container'), data, 3000);
      }, (xhr, textStatus, errorThrown) => {
        Kadenze.UIUtil.showNotice($('#notice_container'), xhr.responseJSON, 3000);
      });
    });
  };

  this.editCategory = (item, event) => {
    this.selected_category(item);
    this.$category_modal.modal('show');
  };

  (() => { this.bindData(data) })()
}
